import { Controller } from "@hotwired/stimulus";
import { Tooltip } from "bootstrap";

export default class extends Controller {
  static targets = ["source"];

  sourceTargetConnected(element) {
    new Tooltip(element);
  }

  sourceTargetDisconnected(element) {
    if (element) {
      const tooltip = Tooltip.getInstance(element);
      if (tooltip) {
        tooltip.dispose();
      }
    }
  }
}
